import { AccountSubscriptionGetDto } from "clearline-api";

export interface AccountSubscription extends AccountSubscriptionGetDto {}
